/**
 * Código de referido del alta. Distinto del catálogo KYC "cómo se enteró".
 * Formato: 4 letras + 7 dígitos, p. ej. ABCD1234567.
 */

export const REFERRAL_CODE_LENGTH = 11;
export const REFERRAL_CODE_PATTERN = /^[A-Z]{4}\d{7}$/;

export const REFERRAL_CODE_ERROR = {
  INVALID_LENGTH: 'REFERRAL_CODE_INVALID_LENGTH',
  INVALID_LENGTH_BACKEND: 'REFERRAL_CODE_INVQLID_LENGTH',
  INVALID_FORMAT: 'REFERRAL_CODE_INVALID_FORMAT',
};

/**
 * Recorta espacios y pasa el código a mayúsculas.
 * @param {string} value
 * @returns {string}
 */
export function normalizeReferralCode(value) {
  return (value || '').replace(/\s/g, '').toUpperCase();
}

/**
 * Vacío es válido porque el código es opcional.
 * @param {string} value
 * @returns {string|null}
 */
export function getReferralCodeError(value) {
  const normalized = normalizeReferralCode(value);
  if (!normalized) {
    return null;
  }
  if (normalized.length !== REFERRAL_CODE_LENGTH) {
    return REFERRAL_CODE_ERROR.INVALID_LENGTH;
  }
  if (!REFERRAL_CODE_PATTERN.test(normalized)) {
    return REFERRAL_CODE_ERROR.INVALID_FORMAT;
  }
  return null;
}

/** Vacío es válido. Un valor presente debe cumplir el formato oficial. */
export function isValidReferralCode(value) {
  return !getReferralCodeError(value);
}

/**
 * Misma validación, con cadena vacía en lugar de null.
 * La usa el formulario que ya estaba en staging.
 * @param {string} value
 * @returns {string}
 */
export function getReferralCodeErrorKey(value) {
  return getReferralCodeError(value) || '';
}
